import { Constant, variableSearch } from '../const';
import { updateLastChange, updateTree } from '../utilities';
import BaseNodeModel from "./BaseNodeModel";

export default class ConditionNodeModel extends BaseNodeModel {
    /**
     * Link model
     * @module ConditionNodeModel
     * @param {Object} source Source port model
     * @param {Object} target Target port model
     * @param {Object} props Pre-defined properties to be applied to model
     * @param {string} id If non-null, link model will use this as its ID
     * @param {Array} points If non-null and has at least 2 elements, use this as link anchor & terminal points
     */
    constructor(nodeName = "UNNAMED", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);
        if (id) {
            this.id = id;
        }
        this.props = {
            nodeTypeName: "Condition",
            colorClass: "primary",
            error: {},
            config: {
                condition: [],
                description: "",
                inputs: [],
                intent: ""
            },
            configView: [],
            permission: {},
        };
        if (props) {
            Object.assign(this.props, props);
        }

    }

    /**
     * Set model property
     * @param {string} key
     * @param {*} valuej
     */
    setProperty(key, value) {
        this.props[key] = JSON.parse(JSON.stringify(value));
    }

    /**
     * Get model property
     * @param {string} key
     * @returns {*}
     */
    getProperty(key) {
        return this.props[key];
    }

    /**
     * Set model config, which corresponds to properties shown by the property panel
     * @param {string} key
     * @param {*} value
     */
    setConfig(key, value) {
        var globalIntentIndex = window.apm.serialized.globalIntents.findIndex(gi => gi.conditionProperties.id === this.id);
        if (this.props.config[key] !== JSON.parse(JSON.stringify(value))) {
            updateLastChange(this.props);
            updateLastChange(window.apm.serialized.globalIntents[globalIntentIndex]);
        }
        if (key === "intent") {
            
            
            const intentIndex = window.apm.serialized.components.intents.findIndex((i) => i.id ===  window.apm.serialized.globalIntents[globalIntentIndex].intent);
            const newIntentIndex = window.apm.serialized.components.intents.findIndex((i) => i.id ===  value);

            if(newIntentIndex !== -1){// checking if the intent exists in the application 
                window.apm.serialized.globalIntents[globalIntentIndex].intent = value;
                window.apm.serialized.components.intents[newIntentIndex].isGlobalIntent = true;
                updateLastChange(window.apm.serialized.components.intents[newIntentIndex].props);
            }
            // check if the intent is used in other globlaIntents if not mark isGlobalIntent as false so that it is visible in application panel
            const isGlobalIntent =  window.apm.serialized.globalIntents.findIndex(gi=>gi.intent === window.apm.serialized.components.intents[intentIndex].id);
            
            if(isGlobalIntent === -1){
                window.apm.serialized.components.intents[intentIndex].isGlobalIntent = false;
            }
            
            updateTree();
        }
        //DevDrew Note: looks like all properties are updated here, so condition seems to require additonal actions
        this.props.config[key] = JSON.parse(JSON.stringify(value));

        if (key === "condition") {
            const oldInputs = this.getConfig("inputs") ? JSON.parse(JSON.stringify(this.getConfig("inputs"))) : [];
            // update transition inputs based on conditions
            this.props.config["inputs"] = [];
            var refs = {};
            for (var i = 0; i < value.length; i++) {
                for (var j = 0; j < value[i].length; j++) {
                    const cond = value[i][j];
                    const m = cond.match(variableSearch);
                    if (!m) {
                        continue;
                    }
                    for (var mi = 0; mi < m.length; mi++) {
                        const sv = m[mi].split(".");
                        var v = null;
                        if (sv[0] === Constant.k.SCOPE_APPLICATION) {
                            v = window.apm.getVariable(sv[1]);
                        }
                        if (sv[0] === Constant.k.SCOPE_MODULE) {
                            v = window.apm.getVariable(sv[1], window.apm.getCurrentDiagramWidget().props.node.id);
                        }
                        if (sv[0] === Constant.k.PARAMETERS) {
                            v = window.apm.getParameter(sv[1]);
                        }
                        if (v) {
                            refs[m[mi]] = true;
                        }
                    }
                }
            }
            const dedupRefs = Object.keys(refs);
            for (var i = 0; i < dedupRefs.length; i++) {
                this.props.config["inputs"].push({
                    argumentName: dedupRefs[i],
                    type: "variable",
                    value: null,
                    varName: dedupRefs[i]
                });
            }
            this.props.config.serializedCondition = this.getPrettyCondition();
            // refresh reference list
            document.dispatchEvent(new CustomEvent("ev-property-item-list-refresh"));
        }
        document.dispatchEvent(new CustomEvent("ev-property-refresh"));
        window.apm.reactDOMComponents.render({ name: "IntentsWidget", props: { serialized: window.apm.serialized }, $el: $("#intents") });

    }

    /**
     * Get model config
     * @param {string} key
     * @returns {*}
     */
    getConfig(key) {
        return this.props.config[key];
    }

    /**
     * Update two-way reference of variables
     * @param {Array} oldInputs
     */
    updateVariables(oldInputs) {
        // Clean up old references
        if (oldInputs) {
            this.removeVariableRefs(oldInputs);
        }
        // Set new references
        const modId = window.apm.getCurrentDiagramWidget().props.node.id;
        if (this.getConfig("inputs")) {
            this.setVariables(this.getConfig("inputs"), modId, "set");
        }
    }

    /**
     * Remove variable references
     */
    removeVariableRefs(oldInputs = null) {
        var inputs = oldInputs;
        if (this.getConfig("inputs") && oldInputs === null) {
            inputs = this.getConfig("inputs");
        }
        if (inputs) {
            const modId = window.apm.getCurrentDiagramWidget().props.node.id;
            this.setVariables(inputs, modId, "del");
        }
    }

    setVariables(vars, modId, op) {
        for (var i = 0; i < vars.length; i++) {
            const v = vars[i];
            const scope = v.varName.split(".")[0];
            const varName = v.varName.split(".")[1];
            if (scope === Constant.k.SCOPE_APPLICATION) {
                if (op === "set") {
                    window.apm.setVariable(varName, v.type, modId);
                }
                if (op === "del") {
                    window.apm.removeVariable(varName, modId);
                }
            }
            if (scope === Constant.k.SCOPE_MODULE) {
                if (op === "set") {
                    window.apm.setVariable(varName, v.type, modId, modId);
                }
                if (op === "del") {
                    window.apm.removeVariable(varName, modId, modId);
                }
            }
        }
    }

   
    /**
     * Set permission
     * @param {string} group Group name
     * @param {Object} value Permission definition
     */
    setPermission(group, value) {
        this.props.permission[group] = value;
    }

    /**
     * Get permission
     * @param {string} group Group name
     * @returns {Object}
     */
    getPermission(group) {
        return this.props.permission[group];
    }

    /**
     * Get all permissions
     * @returns {Object}
     */
    getPermissions() {
        return this.props.permission;
    }

    /**
     * Get the port the link is previously connected to (before re-wiring)
     * @param {string} key Port type key
     * @returns {Object} Port model
     */
    getPreviousPort(key) {
        return this.previousPorts[key];
    }

    /**
     * Set the port the link will be previously connected to after re-wiring
     * @param {string} key Port type key
     * @param {Object} port Port model
     */
    setPreviousPort(key, port) {
        this.previousPorts[key] = port;
    }



    /**
     * Does this model have any conditions?
     * @returns {boolean}
     */
    hasCondition() {
        if (!this.getConfig("condition")) {
            return false;
        }
        const cond = this.getConfig("condition");
        if (cond.length <= 0) {
            return false;
        }
        var hasCond = false;
        // for (var i = 0; i < cond.length; i++) {
        //     for (var j = 0; j < cond[i].length; j++) {
        //         if (cond[i][j]) {
        //             hasCond = true;
        //             break;
        //         }
        //     }
        // }
        return hasCond;
    }
    

    /**
     * Get view configurations for property panel
     * @returns {Array}
     */
    getConfigViews() {
        const configViews = [{
                                    type: "Dropdown", key: "intent", label: "Intent", optionName: "Select Intent",
                                    options:window.apm.knowledgeBase.getIntents()
                                },
                                { type: "Input", label: this.getPropLabel("description"), key: "description" },
                                { type: "hr" },
                                {type:"Label", key:"additionalCondtiion",labelName:"Additional Condition", fontSize:"14"},
                                { type: "Input", label: "Name", key: "name" },
                                {type:"Label", key:"condition",labelName:"Condition"},
                                { type: "Condition", key: "condition" }
                            ];

        return [
            ...configViews,
            ...this.props.configView,
            ...[
                { type: "hr" },
                { type: "ItemList", label: this.getPropLabel("variables_referenced"), key: "inputs", view: "variableReference", readOnly: true }
            ]
        ];
    }

    getPropLabel(key) {
        return window.l.property[key];
    }


    /**
     * Serialize conditions
     */
    serializeCondition(condition) {
        var sc = [];
        for (var i = 0; i < condition.length; i++) {
            var sa = [];
            for (var j = 0; j < condition[i].length; j++) {
                sa.push("(" + condition[i][j] + ")");
            }
            sc.push("(" + sa.join(" && ") + ")");
        }
        if (sc.length) {
            return sc.join(" || ");
        }
        return "true";
    }

    isPureStatement(statement) {
        return !statement.match(/[&|]/i);
    }

    /**
     * Get own serialized condition in pretty print
     * @returns {*}
     */
    getPrettyCondition() {
        const condition = this.getConfig("condition");
        var sc = [];
        for (var i = 0; i < condition.length; i++) {
            var sa = [];
            for (var j = 0; j < condition[i].length; j++) {
                if (this.isPureStatement(condition[i][j])) {
                    sa.push(condition[i][j]);
                } else {
                    sa.push( + condition[i][j] );
                }
            }
            const ssa = sa.join(" && ");
            if (this.isPureStatement(ssa)) {
                sc.push(ssa);
            } else {
                sc.push( sa.join(" && ") );
            }
        }
        if (sc.length) {
            return sc.join(" || ");
        }
        return "";
    }

    /**
     * Serialize model for storage
     * @returns {Object}
     */
    serialize() {
        var s = super.serialize();

        s.props = JSON.parse(JSON.stringify(this.props));
        delete s.props.configView;

        if (s.props.config.condition) {
            s.props.config["serializedCondition"] = this.serializeCondition(s.props.config.condition);
        }
        return s;
    }
}
